import { render } from "./Logo.vue?vue&type=template&id=e0d46d40&scoped=true"
const script = {}

import "./Logo.vue?vue&type=style&index=0&id=e0d46d40&scoped=true&lang=scss"

import exportComponent from "E:\\work9\\wzbz_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0d46d40"]])

export default __exports__